module.exports = __webpack_public_path__ + "img/mean6.3eab8bca.png";